import React, {memo} from 'react'
import {getDisplayName} from '@modifi/utilities'
import {Col, Row, WarningAlert} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {useAbility} from '../../constants/permissions'

const withReadAuthorization = (sectionName: string) => (WrappedComponent: React.ComponentType) => {
  const ScopedComponent = (props: Record<string, any>) => {
    const {t} = useTranslation('shared')
    const ability = useAbility()

    if (!ability.can('read', sectionName)) {
      return (
        <Row mt={30} mb={10} justifyContent="center">
          <Col col={12}>
            <WarningAlert>{t('warning.alert.no-read-access.message')}</WarningAlert>
          </Col>
        </Row>
      )
    }

    return <WrappedComponent {...props} />
  }

  ScopedComponent.WrappedComponent = WrappedComponent
  ScopedComponent.displayName = `withReadAuthorization(${getDisplayName(WrappedComponent)})`

  return memo(ScopedComponent)
}

export default withReadAuthorization
